import React from "react";
import "./PartBar.scss";
import { isB2C, isNovium } from "../../libs/env";
import { size, find, includes } from "lodash";
import { status } from "../../pages/assessment/PagePagination";
import { assessmentType } from "../constants/constants";
import AssessmentWarnings from "../../pages/assessment/assessmentWarnings";

const PartBar = ({
  currentPage,
  onClick,
  pagination_color_decision,
  section_number,
  data,
  answers,
  standing_page,
  section_name,
}) => {
  let className = "grey-border";
  let placement_class = "";
  let placement_test_bar = "";
  let bordercolor = ""; 

  let classNamePlacement ="";


  let assessment_warnings = AssessmentWarnings(data,answers);
  let get_current_section;
  assessment_warnings &&
    assessment_warnings.forEach((assessment_warning) => {
      if (assessment_warning.section_number === section_number) {
        get_current_section = assessment_warning;
      }
    });
  if (true) {
    let find_section = find(pagination_color_decision, [
      "section_number",
      section_number,
    ]);
    let page_ids_which_include_inprogress = [];
    find_section &&
      find_section.pages.forEach((section_page) => {
        if (includes(section_page.status, status.inprogress)) {
          page_ids_which_include_inprogress.push(section_page.page_number);
        }
      });

    if (!get_current_section) {
      className = "success-border";
      placement_class = "completed-page";
      placement_test_bar= "line-bar-active"
      bordercolor = "true"
    } else {
      let inprogress = false;
      if (size(page_ids_which_include_inprogress) > 0) {
        page_ids_which_include_inprogress &&
          page_ids_which_include_inprogress.forEach((inprogress_page_id) => {
            let find_from_current_warning = find(get_current_section.pages, [
              "page_number",
              inprogress_page_id,
            ]);
            if (find_from_current_warning) {
              inprogress = true;
              return;
            }
          });
      }
      if (inprogress) {
        className = "orange-border";
        placement_class="current-page"
        placement_test_bar="bg-current"
      }
    }
  }
  if(standing_page === parseInt(`${section_number}`))
  {
    if (bordercolor === "true"){
      
      classNamePlacement = "completed-border"
    }
    else{
      classNamePlacement = "uncompleted-border"
    }
    placement_class="current-page"
    placement_test_bar="bg-current"
    if(isB2C.some(domain => window.location.origin.includes(domain)) || window.location.origin.includes(isNovium) )
    {
    className = "yellow-border";
    }

  }

  return (
    data.assessment_type === assessmentType.PLACEMENT ? 
    <>
     <li class={`not-started-page ${classNamePlacement} ${placement_class}` }>
      <span class={`bg-completed btn ${placement_test_bar}`}  onClick={() => onClick(currentPage)}>
      {currentPage}
      </span>
      <div class="progress-bar-heading text-nowrap">{section_name}</div>
    </li>
    </>
    :
    <div
      className={`${className} h-100 part-bar  flex-fill bd-highlight`}
      onClick={() => onClick(currentPage)}
    ></div>
  );
};

export default PartBar;
